import {useSelector} from "react-redux";

export const useMyMedia = () => {
	return useSelector((state) => {
		return state.my_media?.data || [];
	});
}